<div [class.disabled-overlay]="isDisabled">
  <div class="formula-builder-component row mat-4 mb-4">
    <div class="col-md-12">
      <div class="row formula-container">
        <div class="col-md-12">
          <div class="row card-title">
            <span
              class="field-name"
              (click)="panelOpened = true"
              [style]="
                (selectedElements.length < 2
                  ? 'font-size: smaller;'
                  : 'font-size: xx-small;') +
                (errorFormula ? 'color: red;' : 'color: gray')
              "
              >
              {{ fieldName }}
              @if (validatingFormula) {
                <mat-spinner
                  [diameter]="selectedElements.length < 2 ? 20 : 14"
                  >
                </mat-spinner>
              }
            </span>
            @if (panelOpened && !isDisabled) {
              <button
                class="expand-collapse-button"
                mat-icon-button
                (click)="panelOpened = false"
                >
                G��
              </button>
            }
            @if (!panelOpened && !isDisabled) {
              <button
                class="expand-collapse-button"
                mat-icon-button
                (click)="panelOpened = true"
                >
                G�+
              </button>
            }
          </div>
          <div class="row formula-box">
            <div
              class="formula-chip-list-container"
              (click)="panelOpened = true"
              >
              <mat-chip-listbox class="row formula-chip-list">
                @for (element of selectedElements; track element; let i = $index) {
                  <span>
                    @if (!cursorElement(element)) {
                      <mat-chip
                        class="formula-chip"
                        >
                        @if (operatorElement(element)) {
                          <span>{{
                            operatorElement(element).operator.symbol
                          }}</span>
                        }
                        @if (constantElement(element)) {
                          <span
                            class="row"
                            (keydown)="onKeyDown($event)"
                            >
                            <input
                              class="col-md-10"
                              matInput
                              class="constant-input"
                        [placeholder]="
                          constantElement(element).constant.displayText
                        "
                              [formControl]="formControllers[i]"
                        [type]="
                          constantElement(element).constant.type.toLowerCase()
                        "
                              required
                              />
                            </span>
                          }
                          @if (dataReferenceElement(element)) {
                            <span>
                              {{
                              dataReferenceElement(element).dataReference.module
                              | titlecase
                              }}:
                              {{ dataReferenceElement(element).dataReference.field }}
                            </span>
                          }
                          @if (referenceElement(element)) {
                            <span>
                              {{
                              referenceElement(element).reference.category.name
                              | titlecase
                              }}:
                              {{ referenceElement(element).reference.field.name }}
                              <button
                                class="row"
                                mat-icon-button
                                (click)="defineFilters(i)"
                                >
                                @if (
                                  !referenceElement(element).reference.filters?.length
                                  ) {
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    enable-background="new 0 0 24 24"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    width="24px"
                                    fill="#aaaaaa"
                                    >
                                    <g>
                                      <path d="M0,0h24 M24,24H0" fill="none" />
                                      <path
                                        d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"
                                        />
                                        <path d="M0,0h24v24H0V0z" fill="none" />
                                      </g>
                                    </svg>
                                  }
                                  @if (
                                    referenceElement(element).reference.filters?.length
                                    ) {
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      enable-background="new 0 0 24 24"
                                      height="24px"
                                      viewBox="0 0 24 24"
                                      width="24px"
                                      fill="#555555"
                                      >
                                      <g>
                                        <path d="M0,0h24 M24,24H0" fill="none" />
                                        <path
                                          d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"
                                          />
                                          <path d="M0,0h24v24H0V0z" fill="none" />
                                        </g>
                                      </svg>
                                    }
                                  </button>
                                </span>
                              }
                              @if (integrationElement(element)) {
                                <span>
                                  {{
                                  integrationElement(element).integration.endpoint.name
                                  }}
                                  -
                                  {{ integrationElement(element).integration.mapping.name }}
                                  <button
                                    class="row"
                                    mat-icon-button
                                    (click)="defineIntegration(i)"
                                    >
                                    <mat-icon
                          [class]="
                            integrationElement(element) &&
                            integrationElement(element).integration.isFormFilled
                              ? 'config-x'
                              : isValidIntegrationMapping(element)
                              ? 'config'
                              : 'config invalid'
                          "
                                      >
                                      settings
                                    </mat-icon>
                                  </button>
                                </span>
                              }
                              @if (customVariableElement(element)) {
                                <span>
                                  {{
                                  customVariableElement(element).customVariable
                                  .variableName ||
                                  customVariableElement(element).customVariable
                                  ?.displayText
                                  }}
                                  @if (
                                    !customVariableElement(element).customVariable
                                    .isConstant
                                    ) {
                                    <button
                                      class="row"
                                      mat-icon-button
                                      (click)="defineCustomVariable(i)"
                                      >
                                      <mat-icon
                          [class]="
                            customVariableElement(element).customVariable
                              .variableName
                              ? 'config'
                              : 'config invalid'
                          "
                                        >
                                        settings
                                      </mat-icon>
                                    </button>
                                  }
                                </span>
                              }
                              @if (externalDataElement(element)) {
                                <span>{{
                                  externalDataElement(element).externalData.displayText
                                }}</span>
                              }
                            </mat-chip>
                          }
                          @if (cursorElement(element) && panelOpened) {
                            <span
                              class="cursor"
                              >|</span
                              >
                          }
                        </span>
                      }
                    </mat-chip-listbox>
                  </div>
                  @if (!isDisabled) {
                    <div class="backspace-button-container">
                      <div class="row">
                        <button
                          [disabled]="isMoveLeftDisabled()"
                          mat-icon-button
                          (click)="moveLeft()"
                          class="arrow-button"
                          matTooltip="Move the cursor left"
                          >
                          <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                        <button
                          [disabled]="isMoveRightDisabled()"
                          mat-icon-button
                          (click)="moveRight()"
                          class="arrow-button"
                          matTooltip="Move the cursor right"
                          >
                          <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                      </div>
                      <button
                        [disabled]="isMoveLeftDisabled()"
                        class="row backspace"
                        mat-icon-button
                        (click)="removeElement()"
                        >
                        <mat-icon>backspace</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
            @if (!isDisabled) {
              <div
                #formulaBuilderContainer
                [style.display]="panelOpened ? 'block' : 'none'"
                class="row formula-builder-container"
                >
                <form class="col-md-12">
                  <mat-form-field width="100%" appearance="fill" class="filter-chips">
                    <mat-label>Filter Chips</mat-label>
                    <input matInput [formControl]="myControl" />
                  </mat-form-field>
                </form>
                <div class="col-md-12">
                  <div class="header">
                    @if (expandAllMainSections) {
                      <button
                        mat-icon-button
                        type="button"
                        matTooltip="{{ 'setup.common.collapse' | translate }}"
                        (click)="expandAllMainSections = false"
                        >
                        <mat-icon> unfold_less </mat-icon>
                      </button>
                    }
                    @if (!expandAllMainSections) {
                      <button
                        mat-icon-button
                        type="button"
                        matTooltip="{{ 'setup.common.expand' | translate }}"
                        (click)="expandAllMainSections = true"
                        >
                        <mat-icon> unfold_more </mat-icon>
                      </button>
                    }
                  </div>
                  <mat-accordion multi>
                    <!-- GENERAL chips -->
                    @if (generalConstants.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header> GENERAL </mat-expansion-panel-header>
                        <mat-chip-listbox class="category-chip-list">
                          @for (constant of generalConstants; track constant) {
                            <mat-chip
                              (click)="selectFormulaElement(constant)"
                              >
                              {{ constant.constant.displayText }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- BRACKETS chips -->
                    @if (bracketOperators.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          BRACKETS
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (operator of bracketOperators; track operator) {
                            <mat-chip
                              (click)="selectFormulaElement(operator)"
                              >
                              {{ operator.operator.displayText }}
                              {{ operator.operator.symbol }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- COMPARATIVE OPERATORS chips -->
                    @if (comparativeOperators.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          COMPARATIVE OPERATORS
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (operator of comparativeOperators; track operator) {
                            <mat-chip
                              (click)="selectFormulaElement(operator)"
                              >
                              {{ operator.operator.displayText }}
                              {{ operator.operator.symbol }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- BASIC OPERATORS chips -->
                    @if (basicOperators.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          BASIC OPERATORS
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (operator of basicOperators; track operator) {
                            <mat-chip
                              (click)="selectFormulaElement(operator)"
                              >
                              {{ operator.operator.displayText }}
                              {{ operator.operator.symbol }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- CONDITIONAL OPERATORS chips -->
                    @if (conditionalOperators.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          CONDITIONAL OPERATORS
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (operator of conditionalOperators; track operator) {
                            <mat-chip
                              (click)="selectFormulaElement(operator)"
                              >
                              {{ operator.operator.displayText }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- CUSTOM VARIABLES hips -->
                    @if (customVariables.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          CUSTOM VARIABLES
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (variable of customVariables; track variable) {
                            <mat-chip
                              (click)="selectFormulaElement(variable)"
                              >
                              {{ variable.customVariable.displayText }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- DATA REFERENCES chips -->
                    @if (dataReferences.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          DATA REFERENCES
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (reference of dataReferences; track reference) {
                            <mat-chip
                              (click)="selectFormulaElement(reference)"
                              >
                              {{ reference.dataReference.module | titlecase }}:
                              {{ reference.dataReference.field }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- EXTERNAL DATA REFERENCES chips -->
                    @if (externalData.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          EXTERNAL DATA REFERENCES
                        </mat-expansion-panel-header>
                        <mat-chip-listbox class="row category-chip-list">
                          @for (element of externalData; track element) {
                            <mat-chip
                              (click)="selectFormulaElement(element)"
                              >
                              {{ element.externalData.displayText }}
                            </mat-chip>
                          }
                        </mat-chip-listbox>
                      </mat-expansion-panel>
                    }
                    <!-- REFERENCES chips -->
                    @if (sectionedReferences.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          REFERENCES
                        </mat-expansion-panel-header>
                        <!-- Reference sections -->
                        @for (
                          sectionedReference of sectionedReferences; track
                          sectionedReference; let i = $index) {
                          <mat-expansion-panel
                            [expanded]="expandAllReferenceSections"
                            class="section-panel mb-2"
                            >
                            <mat-expansion-panel-header>
                              {{ sectionedReference.section }}
                            </mat-expansion-panel-header>
                            <mat-chip-listbox class="row category-chip-list">
                              <!-- Reference categories under section -->
                              @for (
                                reference of sectionedReference.references || []
                                ; track
                                reference) {
                                <mat-expansion-panel
                                  [expanded]="expandAllReferenceCategories"
                                  class="section-panel mb-2"
                                  >
                                  <mat-expansion-panel-header>
                                    {{ reference.name }}
                                  </mat-expansion-panel-header>
                                  <mat-chip-listbox class="row category-chip-list">
                                    @for (field of reference.fields; track field) {
                                      <mat-chip
                                        (click)="selectReference(reference, field)"
                                        >
                                        {{ reference.name | titlecase }}: {{ field.name }}
                                      </mat-chip>
                                    }
                                  </mat-chip-listbox>
                                </mat-expansion-panel>
                              }
                            </mat-chip-listbox>
                          </mat-expansion-panel>
                        }
                      </mat-expansion-panel>
                    }
                    <!-- INTEGRATIONS chips -->
                    @if (integrationEndpoints.length > 0) {
                      <mat-expansion-panel
                        [expanded]="expandAllMainSections"
                        class="category-panel mb-2"
                        >
                        <mat-expansion-panel-header>
                          INTEGRATIONS
                        </mat-expansion-panel-header>
                        <!-- Endpoints -->
                        @for (endpoint of integrationEndpoints; track endpoint; let i = $index) {
                          <mat-expansion-panel
                [expanded]="
                  expandAllIntegrationEndpoints && endpoint.mappings.length > 0
                "
                            class="section-panel mb-2"
                            [disabled]="endpoint.mappings.length === 0"
                            >
                            <mat-expansion-panel-header>
                              {{ endpoint.name }}
                            </mat-expansion-panel-header>
                            <mat-chip-listbox class="row category-chip-list">
                              <!-- Mappings under endpoint -->
                              @for (mapping of endpoint.mappings || []; track mapping) {
                                <mat-chip
                                  (click)="selectIntegrationMapping(endpoint, mapping)"
                    [disabled]="
                      !integrationMappingConfigurationsValid(endpoint, mapping)
                    "
                                  >
                                  {{ mapping.name | titlecase }}
                                </mat-chip>
                              }
                            </mat-chip-listbox>
                          </mat-expansion-panel>
                        }
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
